import { reduxKey } from '../../constants';
import { createAction } from 'redux-actions';
import { DamzState } from '../../types';

export const initUserSettings = createAction(
  `${reduxKey}.SETTINGS_INIT`,
  (settings: DamzState['settings']) => settings
);

export const fetchMenuSettings = createAction(
  `${reduxKey}.SETTINGS_FETCH_MENU`,
  () => ({})
);

export const fetchMenuSettingsSuccess = createAction(
  `${reduxKey}.SETTINGS_FETCH_MENU_SUCCESS`,
  (settings: DamzState['settings']) => settings
);

export const fetchMenuSettingsFailure = createAction(
  `${reduxKey}.SETTINGS_FETCH_MENU_FAILURE`,
  () => ({})
);

export const setDisableSounds = createAction(
  `${reduxKey}.SETTINGS_DISABLE_SOUNDS`,
  (disable: boolean) => ({ disable })
);

export const setOnlyMyWatchers = createAction(
  `${reduxKey}.SETTINGS_ONLY_MY_WATCHERS`,
  (only: boolean) => ({ only })
);
